theme.config = (function(){
  const durations = {
    short: 100,
    default: 200,
    announcement_bar: 250,
    medium: 300,
    long: 500,
    extra_long: 600,
    extra_longer: 750,
    extended: 3000,
  };

  return {
    durations
  }
})();